export class EventBus {
    constructor() {
        this.listeners = {};
    }
    on(eventName, listener) {
        let eventListeners = this.listeners[eventName];
        if (!eventListeners) {
            eventListeners = [];
            this.listeners[eventName] = eventListeners;
        }
        eventListeners.push(listener);
    }
    off(eventName, listener) {
        const eventListeners = this.listeners[eventName];
        if (eventListeners) {
            const i = eventListeners.indexOf(listener);
            if (!eventListeners || i < 0) {
                return;
            }
            eventListeners.splice(i, 1);
        }
    }
    dispatch(event) {
        // console.log('PdfViewer Event Bus', event.type, event.payload);
        const eventListeners = this.listeners[event.type];
        if (!eventListeners || eventListeners.length === 0) {
            return;
        }
        eventListeners.slice(0).forEach(listener => listener.apply(null, [event]));
    }
}
//# sourceMappingURL=event-bus.js.map